import isEmpty from "lodash/isEmpty";
import keys from "lodash/keys";
import values from "lodash/values";
import { cameraService } from "client-app-core";

/**
 * utils is a singleton
 * It runs only once when the module is loaded. Its purpose is to download client-side scripts 
 * needed for the AVIGILON video player and inject them into the HTML; 
 * fetch, cache and provide tokens to individual video player instances, 
 * and refresh those tokens at regular intervals to prevent login expiration.
 * 
 */
const utils = (() => {
    const TOKEN_EXPIRATION_SECONDS = 3600;
	let scriptsLoadStatus = "NOT_LOADED";
	let numScriptsLoaded = 0;

    const injectAvigilonsScriptIntoRootHtml = async (url, type = "", id) => {
		try {
			const response = await fetch(url, {
				method: "GET"
			});

			if (!response.ok) {
				throw new Error("Network response was not ok " + response.statusText);
			}

			const scriptContent = await response.text();

			const script = document.createElement("script");
			script.id = id;
			script.textContent = scriptContent;
			if (type !== "") {
				script.type = type;
			}
			document.body.appendChild(script);
		} catch (error) {
			console.error("injectAvigilonsScriptIntoRootHtml: There was a problem with fetching or appending the script:", error);
			throw error; // Rethrow the error to ensure the calling function also fails
		}
	}

    const scriptUrls = [
		"/_fileDownload/avigilon-video/unity-player.js"
	];
    
	const unloadScripts = id => {
		const existingScript = document.getElementById(id);
		if (existingScript) {
			existingScript.remove();// older way is existingScript.parentNode.removeChild(existingScript);
		}
	};

    const loadScripts = async () => {
        if (scriptsLoadStatus === "NOT_LOADED") {
            scriptsLoadStatus = "LOADING";
            try {
                for (let i = numScriptsLoaded; i < scriptUrls.length; i++) {
                    await injectAvigilonsScriptIntoRootHtml(
                        scriptUrls[i],
                        "module",
                        "avigilon-unityPlayer" //`avigilon-${["unityPlayer", "camera", "wepHelper"][i]}`
                    );
                    numScriptsLoaded++;
                }

                scriptsLoadStatus = "LOADED";

				//Todo: Here refresh token and setInterval to refresh token frequently.
                //refreshToken();
                //setInterval(refreshTokens, TOKEN_EXPIRATION_SECONDS * 1000);

            } catch (error) {
				scriptsLoadStatus = "NOT_LOADED";
                console.error("Avigilon: Error loading scripts:", error);
            }
        }
	};

	// const refreshTokens = async (url, cameraId) => {
	// 		video player has method "refreshToken() to updates the authentication token for the connected player."
	//		Incase didnt worked then write logic to refresh.
	// };

    const get16by9Dimensions = (width, height) => {
		// Check for valid width and height
		if (typeof width !== "number" || width <= 0 || typeof height !== "number" || height <= 0) {
			console.error(`Avigilon: Invalid dimensions provided (${width}, ${height}). Must be a positive number.`);
			return null;
		}
	
		const aspectRatioHeight = 9;
		const aspectRatioWidth = 16;
	
		let calculatedWidth = width;
		let calculatedHeight = Math.floor((calculatedWidth * aspectRatioHeight) / aspectRatioWidth);
	
		if (calculatedHeight > height) {
			calculatedHeight = height;
			calculatedWidth = Math.floor((calculatedHeight * aspectRatioWidth) / aspectRatioHeight);
		}
	
		return {
			width: calculatedWidth, 
			height: calculatedHeight
		};
	};

    return {
        loadScripts,
		unloadScripts,
		get16by9Dimensions
	};
})();

export default utils;